import React, { useEffect, useState } from 'react';
import DateFormatConverter from '../../../../components/input/DateFormatConvert';
import Label from '../../../../components/title/label';
import { Navbar } from '../../../../components/navbar/Navbar';
import BackButton from '../../../../components/button/BackButton';
import axios from 'axios'; // Utiliser axios pour effectuer des requêtes HTTP
import { BACKEND_URL } from '../../../../constants/constant';

function VoirEnDetailHistorique() {
  // Contenu de la barre de navigation
  const NavbarContent = (
    <div className='flex justify-between'>
      <div className='text-white font-semibold'>
        Voir détail Historique
      </div>
      <div>
        <BackButton to="/MouvementHistorique"></BackButton>
      </div>
    </div>
  );

  // État local pour stocker les données du recepisse et gérer les erreurs
  const [recepisse, setRecepisse] = useState(null);
  const [error, setError] = useState(null); // État pour gérer les erreurs

  // Récupérer le numero_recepisse depuis le localStorage
  const Recette = localStorage.getItem("selectedDataMouvementHistorique");
  const selectedRecepisse = JSON.parse(Recette);

  // Fonction useEffect pour faire la requête au backend
  useEffect(() => {
    if (selectedRecepisse?.numero_recepisse) {
      axios.get(`${BACKEND_URL}/recette/getEnregistrementdeclarationByRecepisse/${selectedRecepisse.numero_recepisse}`)
        .then(response => {
          setRecepisse(response.data); // Met à jour l'état avec les données
          setError(null); // Réinitialise l'erreur si les données sont trouvées
        })
        .catch(error => {
          console.error("Erreur lors de la récupération des données :", error); // Log l'erreur
          if (error.response && error.response.status === 404) {
            // Si le statut est 404, afficher une page d'erreur 404
            setError("Donnée supprimée ou non trouvée.");
          } else {
            // Gérer d'autres types d'erreurs
            setError("Erreur lors de la récupération des données.");
          }
        });
    }
  }, [selectedRecepisse?.numero_recepisse]); // Dépendance sur numero_recepisse

  // Si une erreur est survenue, afficher la page d'erreur avec le message approprié
  if (error) {
    return (
      <div className='bg-[#212122] h-screen w-full flex flex-col justify-center items-center'>
        <h1 className='text-white text-3xl mb-4'>{error}</h1>
        <p className='text-white'>Une erreur s'est produite lors de la tentative de récupération des données.</p>
        <BackButton to="/MouvementHistorique" />
      </div>
    );
  }

  // Si recepisse n'est pas encore chargé, afficher un message de chargement
  if (!recepisse) {
    return <div className='text-white'>Chargement des données...</div>;
  }

  // Rendu de la page lorsque les données sont disponibles
  return (
    <div className='bg-[#212122] h-screen w-full'>
      <Navbar content={NavbarContent}></Navbar>
      <div className='flex justify-center'>
        <div className='flex flex-col w-[400px] h-[200px] mt-8'>
          <Label text="Raison sociale" className="font-semibold m-2"></Label>
          <Label text="Activité" className="font-semibold m-2"></Label>
          <Label text="Adresse" className="font-semibold m-2"></Label>
          <Label text="Commune" className="font-semibold m-2"></Label>
          <Label text="Nature Impôt" className="font-semibold m-2"></Label>
          <Label text="Numéro Impot" className="font-semibold m-2"></Label>
          <Label text="Référence fiscale" className="font-semibold m-2"></Label>
          <Label text="Numéro recepissé" className="font-semibold m-2"></Label>
          <Label text="Type de payment" className="font-semibold m-2"></Label>
          <Label text="Période" className="font-semibold m-2"></Label>
          <Label text="Période 1" className="font-semibold m-2"></Label>
          <Label text="Période 2" className="font-semibold m-2"></Label>
          <Label text="Montant verser" className="font-semibold m-2"></Label>
          <Label text="Montant à payer" className="font-semibold m-2"></Label>
          <Label text="Reste à payer " className="font-semibold m-2"></Label>
          <Label text="Code opérateur" className="font-semibold m-2"></Label>
          <Label text="Date de payment" className="font-semibold m-2"></Label>
        </div>
        <div className='flex flex-col w-[400px] h-[200px] mt-8'>
          <Label text={recepisse?.raison_social || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.activite || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.adresse || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.commune || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.base_impot || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.numero_impot || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.reference_fiscal || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.numero_recepisse || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.type_payment || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.periode || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.periode1 || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.periode2 || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.montant_verser || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.montant_a_payer || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.reste_a_payer || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.code_operateur || "aucune"} className="font-semibold m-2"></Label>
          <DateFormatConverter isoDate={recepisse?.date_creation || "aucune"} className="font-semibold text-white m-2"></DateFormatConverter>
        </div>
      </div>
    </div>
  );
}

export default VoirEnDetailHistorique;
